import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ChangeDeviceService {
    isPortraitDevice = false;
    changedDevice: Subject<boolean> = new Subject<boolean>();

    constructor() {
        this.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });
    }

    changeDevice(isPortraitDevice: boolean) {
        this.changedDevice.next(isPortraitDevice);
    }
}
